/* global translations */
import React from 'react';
import get from 'lodash/get';

const DeleteMeTitle = () => (
  <div className="headerBox">
    <div className="headerBox-title">
      {get(translations, 'txt: Dzēst profilu', '')}
    </div>
  </div>
);

export default DeleteMeTitle;
